import React, { useEffect } from 'react';

import {Handle, useUpdateNodeInternals} from 'react-flow-renderer';

const colors = {
  target: '#656565',
  source: 'red',
};

const Handler = ({style = {}, isValidConnection, ...props}) => {

  const updateNodeInternals = useUpdateNodeInternals(props?.node?.id);
  
  useEffect(() => {
    setTimeout(() => {
      // updateNodeInternals(props.node.id);
      if(props && props.node && props.node.id) updateNodeInternals(props.node.id)
    }, 0);
  }, [props]);

  return (
    <Handle
      {...props}
      // id={id}
      style={{
        width: 10,
        height: 10,
        ...style,
        //  background: colors[props.type]
      }}
    />
  );
};

export default Handler;
